import { coreReducer } from './coreReducer';
import { coreActions } from './coreActions';
import { coreSagas } from './coreSagas';
export default {
    reducer: coreReducer,
    actions: coreActions,
    sagas: coreSagas,
};
